import { Pipe, PipeTransform } from '@angular/core';
import { SharedSearchFilterService } from './search-filter.component';


@Pipe({ name: 'notificationsAdminFoundPipe', pure: true })
export class NotificationsAdminFoundPipe implements PipeTransform {

    constructor(public searchFilterService: SharedSearchFilterService) { }

    transform(item: any, input: string): any { return this.find(item, input) }
    find(item: any, input: string): Boolean { return this.searchFilterService.notificationsAdminFilter(item, input) }
}


@Pipe({ name: 'newsFoundPipe', pure: true })
export class NewsFoundPipe implements PipeTransform {

    constructor(public searchFilterService: SharedSearchFilterService) { }

    transform(item: any, input: string): any { return this.find(item, input) }
    find(item: any, input: string): Boolean { return this.searchFilterService.newsFilter(item, input) }
}

@Pipe({ name: 'newsAdminFoundPipe', pure: true})
export class NewsAdminFoundPipe implements PipeTransform {

    constructor(public searchFilterService: SharedSearchFilterService) { }

    transform(item: any, input: string): any { return this.find(item, input) }
    find(item: any, input: string): Boolean { return this.searchFilterService.newsAdminFilter(item, input) }
}

@Pipe({ name: 'pendientesFoundPipe', pure: true })
export class PendientesFoundPipe implements PipeTransform {

    constructor(public searchFilterService: SharedSearchFilterService) { }

    transform(item: any, input: string): any { return this.find(item, input) }
    find(item: any, input: string): Boolean { return this.searchFilterService.pendientesFilter(item, input) }
}

@Pipe({ name: 'historialFoundPipe', pure: true })
export class HistorialFoundPipe implements PipeTransform {

    constructor(public searchFilterService: SharedSearchFilterService) { }

    transform(item: any, input: string): any { return this.find(item, input) }
    find(item: any, input: string): Boolean { return this.searchFilterService.historialFilter(item, input) }
}
